export default "__VITE_ASSET__Dju1c0T8__"